import { isEmpty, get } from 'lodash';

function hasAtLeastOneResponse(assessment) {
  return !isEmpty(get(assessment, 'responses', []));
}

export default hasAtLeastOneResponse;
